module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/image-placeholder-774f14e36a9d299be361a32ecd71648f.svg";